import React, { useEffect, useState } from 'react';
import Tiers from '../common/tiers/Tiers';
import { stateRender } from '../../../helpers/react';
import { PARAM_NAMES } from '../../../constants/Checkout';
import Button from '../../common/buttons/onboarding/OnboardingButton';
import {
	ONBOARDING_TIER_OPTIONS_TITLE,
	ONBOARDING_TIER_OPTIONS_TITLE_TV_GEMIST,
	ONBOARDING_TIER_OPTIONS_SUBTITLE_TV_GEMIST,
	ONBOARDING_TIER_OPTIONS_SUBTITLE_PROMO,
	ONBOARDING_TIER_OPTIONS_SUBTITLE_PROMO_BENEFIT,
	ONBOARDING_TIER_OPTIONS_SUBTITLE_NON_PROMO,
	BLACK_FRIDAY,
	TIERS_MAKE_CHOICE,
	PRICE_INCREASE,
	PRICE_INCREASE_HELP_LINK,
	SAVOD_SCREENS_INFO,
} from '../../../constants/Copy';

import {
	getTierOptionsProceedUrl,
	getTierFromCollection,
	getPromoPriceForTier,
	getNonPromoPriceForTier,
	getTierPosition,
	getPresentationForTier,
	isPromoTierOptionsPage,
	getTitleForTier,
	getTierPrice,
} from '../../../helpers/tiers';
import { EVT_TIER_OPTION_CONFIRM } from '../../../constants/EventTypes';

import { TierOptionsVoucherLink } from './TierOptionsVoucherLink';
import Message from '../../common/message/Message';
import Heading, { HEADING_SIZE } from '../../common/heading/Heading';
import { useDispatch, useSelector } from 'react-redux';
import { analyticsPush } from '../../../actions/applicationActions';
import { hasValidVideolandCookie } from '../../../helpers/authentication';
import { toggleTieringSidebar } from '../../../actions/tierActions';
import { matchPath, useHistory, useLocation } from 'react-router';
import { useVideolandAccountState } from '../../../hooks/useVideolandAccountState';
import { useTierOptionsDataResolver } from './useTierOptionsDataResolver';
import OnboardingProgress from '../common/onboardingProgress/OnboardingProgress.container';
import { TIER_IDS, RATEPLAN_TIERID_MAP } from '../../../constants/Tiers';
import { ROUTE_TIER_OPTIONS, ROUTE_TIER_OPTIONS_WINBACK } from '../../../constants/Routes';
import useSearchParams from '../../../hooks/useSearchParams';
import { getExperiment, getTrialPeriodText } from '../../../helpers/sitespect';
import { SITESPECT_EXPERIMENT, SITESPECT_EXPERIMENT_NAMES } from '../../../constants/Sitespect';
import OnboardingUserStatus from '../common/onboardingUserStatus/OnboardingUserStatus';
import {
	EVT_SUBSCRIPTION_CATEGORY,
	EVT_SUBSCRIPTION_SELECT,
} from '../../../constants/SnowplowEvents';
import { initiateTrackStructEvent } from '../../analytics/Snowplow';
import { getProceedText, proceedToPushUrl } from '../common/onboardingHelpers';
import ProductionConfig from '../../../../../config/production';
import { redirectToWinbackPage } from '../../../helpers/redirect';
import Icon from '../../common/icons/Icon';
import { SavodTierStep } from './SavodTierStep';
import cx from 'classnames';
import './TierOptions.scss';

export default function TierOptionsContainer() {
	const history = useHistory();
	const location = useLocation();
	const tierCollection = useSelector((state) => state.tiers.collection || []);
	const savodTierCollection = useSelector((state) => state.tiers.savodCollection || []);
	const isTiersError = useSelector((state) => state.tiers.error);
	const dispatch = useDispatch();
	const dispatchAnalyticsPush = (payload, eventType) => dispatch(analyticsPush(payload, eventType));
	const toggleSidebar = (isOpened) => dispatch(toggleTieringSidebar(isOpened));
	const isLoggedIn = hasValidVideolandCookie();
	const isPromoPage = isPromoTierOptionsPage(location.pathname);
	const searchParams = useSearchParams();
	const trialExperimentValue = getExperiment(SITESPECT_EXPERIMENT_NAMES.TRIAL_EXPERIMENT);
	const isPromoAllowed = trialExperimentValue
		? trialExperimentValue === SITESPECT_EXPERIMENT.CONTROL
		: true;

	const savodExperiment = getExperiment(SITESPECT_EXPERIMENT_NAMES.SAVOD);
	const isSavodExperiment = savodExperiment === SITESPECT_EXPERIMENT.VARIANT;
	useTierOptionsDataResolver();

	const planSlug = searchParams.getSearchParam('pakket');
	let preSelectedTier = planSlug && RATEPLAN_TIERID_MAP[planSlug];
	const tierMapping = {
		[TIER_IDS.PREMIUM_WITH_ADS]: TIER_IDS.PREMIUM,
		[TIER_IDS.STANDARD_WITH_ADS]: TIER_IDS.STANDARD,
	};
	preSelectedTier = tierMapping[preSelectedTier] || preSelectedTier;

	const {
		showPromo,
		isLoading: isAccountStatePending,
		isError: isAccountStateError,
		isBlackFriday,
		isPristine: isAccountStatePristine,
		priceIncrease,
	} = useVideolandAccountState(isPromoPage);

	const isOnPromoRoute = !!matchPath(location.pathname, {
		path: ROUTE_TIER_OPTIONS,
		exact: true,
	});

	const isOnNoPromoRoute = !!matchPath(location.pathname, {
		path: ROUTE_TIER_OPTIONS_WINBACK,
		exact: true,
	});

	if (isLoggedIn && !isAccountStatePending && !isAccountStatePristine) {
		if (!showPromo && isOnPromoRoute) {
			if (window.location.href.includes(ProductionConfig.host)) {
				redirectToWinbackPage();
			} else {
				history.push(ROUTE_TIER_OPTIONS_WINBACK);
			}
		} else if (showPromo && isOnNoPromoRoute) {
			history.push(ROUTE_TIER_OPTIONS);
		}
	}

	const [selectedTierId, setSelectedTierId] = useState(preSelectedTier || TIER_IDS.PREMIUM);
	const [isSavodTierSelected, setIsSavodTierSelected] = useState(false);
	const [selectedSavodTier, setSelectedSavodTier] = useState(false);
	const isError = isTiersError || isAccountStateError;

	useEffect(() => {
		if (
			isSavodExperiment &&
			savodTierCollection.length > 0 &&
			(preSelectedTier === TIER_IDS.PREMIUM || preSelectedTier === TIER_IDS.STANDARD)
		)
			setIsSavodTierSelected(true);
	}, [isSavodExperiment, preSelectedTier, savodTierCollection.length]);

	function onClickProceed(selectedTier, proceedText) {
		const tierPrice = showPromo
			? getPromoPriceForTier(selectedTier)
			: getNonPromoPriceForTier(selectedTier);
		const tierPresentation = getPresentationForTier(selectedTier);
		const tierPosition = getTierPosition(selectedTier.id, tierCollection);

		dispatchAnalyticsPush(
			{
				label: proceedText,
				productName: tierPresentation?.title,
				productPrice: tierPrice,
				productPosition: tierPosition,
			},
			EVT_TIER_OPTION_CONFIRM
		);
	}

	return stateRender({
		isError,
		onSuccess: renderContent,
	});

	function renderContent() {
		const isFreeTierSelected = selectedTierId && selectedTierId === TIER_IDS.FREE;
		const selectedTier =
			savodTierCollection && getTierFromCollection(savodTierCollection, selectedTierId);

		const referral = searchParams.getSearchParam(PARAM_NAMES.REFERRAL);
		const showBlackFridayText =
			isBlackFriday &&
			selectedTierId &&
			(selectedTierId === TIER_IDS.ESSENTIAL || selectedTierId === TIER_IDS.STANDARD);
		const savodTier =
			selectedTier && savodTierCollection.find(({ id }) => id === `${selectedTier.id}_WITH_ADS`);
		const proceedUrl = getTierOptionsProceedUrl(
			selectedSavodTier ? savodTier : selectedTier,
			isLoggedIn,
			showPromo,
			referral,
			showBlackFridayText,
			isPromoAllowed
		);
		const proceedText =
			selectedTier &&
			getProceedText({
				showPromo,
				title: getTitleForTier(selectedTier).title,
			});

		const tierPrice = selectedTier && getTierPrice(showPromo, selectedTier);
		const savodTierPrice = savodTier && getTierPrice(showPromo, savodTier);

		return (
			<div data-test="tier-options" className="onboarding">
				<div className="tier-options-progress-container">
					<OnboardingProgress activeStep={1} />
				</div>
				{isSavodTierSelected ? (
					<SavodTierStep
						selectedTier={selectedTier}
						setSelectedSavodTier={setSelectedSavodTier}
						selectedSavodTier={selectedSavodTier}
						tierPrice={tierPrice}
						setIsSavodTierSelected={setIsSavodTierSelected}
						savodTierPrice={savodTierPrice}
						proceedText={proceedText}
						onClickProceed={onClickProceed}
						proceedUrl={proceedUrl}
					/>
				) : (
					<div className="tier-options">
						<Heading size={HEADING_SIZE.MEDIUM}>
							{isFreeTierSelected
								? ONBOARDING_TIER_OPTIONS_TITLE_TV_GEMIST
								: ONBOARDING_TIER_OPTIONS_TITLE}
						</Heading>
						<div className="tier-options__intro">
							<div
								className={cx('onboarding__text', {
									['onboarding__text-savod']: isSavodExperiment,
								})}
								data-test="email-verified-tiers-title"
							>
								{isFreeTierSelected ? (
									<Message
										message={ONBOARDING_TIER_OPTIONS_SUBTITLE_TV_GEMIST.message}
										values={{
											benefit: (
												<strong>{ONBOARDING_TIER_OPTIONS_SUBTITLE_TV_GEMIST.benefit}</strong>
											),
										}}
									/>
								) : showPromo && isPromoAllowed ? (
									<span data-test="tier-options-promo-message">
										{isBlackFriday ? (
											<>
												<Message
													message={BLACK_FRIDAY.ONBOARDING_TIER_OPTIONS_SUBTITLE_PROMO}
													values={{
														benefit: (
															<strong>
																{getTrialPeriodText(
																	BLACK_FRIDAY.ONBOARDING_TIER_OPTIONS_SUBTITLE_PROMO_BENEFIT
																)}
															</strong>
														),
													}}
												/>
												<br />
												<p className="tier-options-black-friday">
													<Icon name="exclamation_mark" viewBox="2 2 20 20" />
													<span
														className="tier-options-black-friday__terms"
														// eslint-disable-next-line react/no-danger
														dangerouslySetInnerHTML={{
															__html: BLACK_FRIDAY.TERMS_LINK,
														}}
													/>
												</p>
											</>
										) : (
											<Message
												message={ONBOARDING_TIER_OPTIONS_SUBTITLE_PROMO}
												values={{
													benefit: (
														<strong>
															{getTrialPeriodText(ONBOARDING_TIER_OPTIONS_SUBTITLE_PROMO_BENEFIT)}
														</strong>
													),
												}}
											/>
										)}
									</span>
								) : (
									<span data-test="tier-options-non-promo-message">
										<Message message={ONBOARDING_TIER_OPTIONS_SUBTITLE_NON_PROMO} />
									</span>
								)}
							</div>
						</div>
						<Tiers
							tiers={tierCollection}
							isPromo={showPromo}
							isPromoAllowed={isPromoAllowed}
							selectedTier={selectedTier}
							toggleSidebar={toggleSidebar}
							onSelectTier={setSelectedTierId}
							proceedUrl={proceedUrl}
							onClickProceed={onClickProceed}
							isSavodTierSelected={isSavodTierSelected}
							setIsSavodTierSelected={setIsSavodTierSelected}
							isSavodExperiment={isSavodExperiment}
						>
							<TierOptionsVoucherLink />
						</Tiers>
						{priceIncrease ? (
							<div className="tier-options-price-increase-basis">
								<p>{PRICE_INCREASE}</p>
								{/* eslint-disable-next-line react/no-danger*/}
								<p dangerouslySetInnerHTML={{ __html: PRICE_INCREASE_HELP_LINK }} />
							</div>
						) : null}
						<div className="fixed-button">
							{selectedTier ? (
								<Button
									testId="tiers-proceed-button"
									className="onboarding-button--tier-button"
									onClick={async () => {
										await initiateTrackStructEvent({
											category: EVT_SUBSCRIPTION_CATEGORY,
											action: EVT_SUBSCRIPTION_SELECT,
										});
										onClickProceed(selectedTier, proceedText);
										isSavodExperiment &&
										(selectedTier.id === TIER_IDS.PREMIUM || selectedTier.id === TIER_IDS.STANDARD)
											? setIsSavodTierSelected(true)
											: proceedToPushUrl(proceedUrl);
									}}
								>
									{isSavodExperiment ? 'Ga verder' : proceedText}
								</Button>
							) : (
								<Button
									testId="tiers-proceed-button-disabled"
									disabled
									className="onboarding-button--tier-button"
								>
									{TIERS_MAKE_CHOICE}
								</Button>
							)}
						</div>
						<OnboardingUserStatus isLoggedIn={isLoggedIn} />
						<p className="tiers-info-savod">{SAVOD_SCREENS_INFO}</p>
					</div>
				)}
			</div>
		);
	}
}
